import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import Duration from '../services/Duration';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faPauseCircle } from '@fortawesome/free-solid-svg-icons';
class Player extends Component {
  constructor(props) {
    super(props);
    this.player = React.createRef();
    this.state = {
      playing: false,
      controls: false,
      played: 0,
      duration: 0
    };
    this.playPause = this.playPause.bind(this);
    this.onDuration = this.onDuration.bind(this);
    this.onProgress = this.onProgress.bind(this);
  }

  playPause() {
    this.setState({ playing: !this.state.playing });
  }

  onProgress(state) {
    if (!this.state.seeking) {
      this.setState(state);
    }
  }

  onDuration(duration) {
    this.setState({ duration });
  }

  render() {
    const { playing, controls, played, duration } = this.state;
    const { url } = this.props;
    return (
      <tr>
        <td className="controls">
          <FontAwesomeIcon icon={playing ? faPauseCircle : faPlayCircle} onClick={this.playPause} />
        </td>
        <td className="align-middle">{this.props.songName}</td>
        <td className="align-middle d-none d-sm-block">
          <progress max={1} value={played} />
        </td>
        <td className="align-middle">
          <Duration seconds={duration * played} />
          <span> / </span>
          <Duration seconds={duration} />
        </td>
        <td>
          <ReactPlayer
            ref={this.player}
            className="react-player"
            width="100%"
            height="100%"
            url={url}
            playing={playing}
            controls={controls}
            light={false}
            loop={false}
            playbackRate={1.0}
            volume={0.8}
            onPlay={() => this.setState({ playing: true })}
            onPause={() => this.setState({ playing: false })}
            onProgress={this.onProgress}
            onDuration={this.onDuration}
          />
        </td>
      </tr>
    );
  }
}

export default Player;
